import { api } from '@/lib/api/client';
import type { UserProfile } from '@/lib/api/types';

export const authApi = {
  login: (username: string, password: string) =>
    api.post<{ accessToken: string; user: UserProfile }>('/auth/login', { username, password, client: 'web' }).then((r) => r.data),
  me: () => api.get<UserProfile>('/auth/me').then((r) => r.data),
  logout: () => api.post('/auth/logout'),
  changePassword: (currentPassword: string, newPassword: string) =>
    api.post<{ accessToken: string }>('/auth/change-password', { currentPassword, newPassword }).then((r) => r.data),
};
